const Directions = Object.freeze({
    WAYPOINT_FORWARD: Symbol('waypointForward'),
    WAYPOINT_BACKWARD: Symbol('waypointBackward'),
    ITEM: Symbol('item'),
    BACK: Symbol('back'),
});

export default Directions;
